import Login from './login';
import { LoginProvider } from './use-login';

const LoginContainer = () => {
  return (
    <LoginProvider>
      <Login />
    </LoginProvider>
  );
};

export default LoginContainer;
